export default {
  views: {
    basket: {
      shopNow: 'Achetez maintenant',
      yourBasket: '<strong>Votre panier</strong> ({0} articles): <strong>{1}</strong>',
      noItems: 'Nous avons des trucs sympas que votre panier adorerait!',
      licenseTitle: 'Licence (s) et frais de retard',
      licenseTotal: 'Total Licensing Fees',
      replacementTitle: 'Étiquettes de remplacement',
      tagTitle: 'Tags pour animaux de compagnie',
      petProductTitle: 'Produits et abonnements pour animaux',
      productTitle: 'Des produits',
      walletCardProductTitle: 'Carte de portefeuille',
      duplicateWalletCard: 'Carte de portefeuille en double',
      petIdentificationCard: "Carte d'identité des animaux",
      walletCardMissingInfo: "L'information manquante dans vos carte de portefeuille!",
      walletCardFinishPet: "Fini {petName}'s carte",
      walletCardAssignPet: 'Attribuer un animal à votre carte',
      additionalFeesTitle: 'Additional Fees',
      donationTitle: 'Des dons',
      vsTitle: 'Articles pour Voice & Sight',
      vsPetTitle: 'Animaux domestiques',
      vsGuardianTitle: "Propriétaire d'animal ou tuteurs",
      addAnother: [
        'ACHETEZ PLUS ET ÉCONOMISEZ PLUS SUR LES ÉTIQUETTES!',
        'Ajoutez une autre étiquette et économisez 5 $!',
        'Ajoutez une autre étiquette et économisez 15 $!!',
        'Ajoutez une autre étiquette pour seulement 10 $!',
      ],
      checkout: 'Vérifier',
      login: 'Login to Checkout',
      continueShopping: 'Continuer vos achats',
      shipping: 'Free shipping on all orders over $00.00',
      returnPolicy: 'Something about our return policy',
      warranty: 'Something about our warranty',
      tooltip: {
        penaltyFee:
          'License fees are subject to a penalty if any person fails to pay the required license renewal fee within thirty (30) days of its due date. Penalty fees are cumulative based on the number of years a pet failed to be licensed.',
      },
      petTrackerAddedMessaging:
        '<strong>{petName} is so lucky! </strong> Now you can stay connected to his location, health and activity' +
        ' with real-time insights right from your phone.',
    },
    confirmation: {
      thanks: 'Merci pour votre achat!',
      orderNumber: 'Commande n ° {0}',
      gettingReady: "Nous préparons votre commande pour l'expédition. Nous vous informerons quand il aura été envoyé.",
      toAccount: 'Accéder à mon Compte',
      viewOrder: 'Voir votre commande',
      summary: 'Récapitulatif de la commande',
      membershipCTA: {
        title: 'Plus de soutien pour vous et vos animaux',
        body: "Découvrez les avantages d'adhésion améliorés qui rendent les soins quotidiens de votre animal amusants et faciles.",
        button: 'Explorez les abonnements',
      },
    },
    interrupt: {
      title: 'Cette médaille n’est pas valide comme licence pour animal!',
      body: 'Nous sommes le partenaire officiel de délivrance des licences pour {cityName}. Afin que la ou les médailles choisies servent aussi de licence pour votre animal, vous devez acheter une licence en plus de la ou des médailles sélectionnées.',
      buttonPurchaseLicense: 'Achetez votre licence pour animal dès maintenant!',
      buttonContinue: 'Je comprends. J’achèterai une licence pour animal plus tard!',
    },
    donation: {
      wouldYouLike: 'Souhaitez-vous faire un don à notre Safe&Happy Fund?',
      netProceeds:
        "Tous les bénéfices nets sont reversés à l'assistance {0}. Si vous souhaitez recevoir un reçu aux fins d’impôt, veuillez faire un don directement à votre refuge local ou à votre organisme de services aux animaux.",
      selectAmount: 'Sélectionnez le montant de votre don',
      continue: 'Ajouter un don et continuer à payer',
      skip: "Pas de don aujourd'hui, merci - Continuer",
      cartTotal: 'Total du panier: {0}',
      roundUpDonation: '<b>Round up my order to {0}</b><br />A donation of {1}',
      validation: {
        min: 'Le montant minimum des dons personnalisés est de {min} $.',
        max: 'Le montant maximal des dons personnalisés est de {max} $.',
        invalid: 'Veuillez saisir un montant de don valide.',
      },
    },
    payment: {
      donationSuccess: 'Don ajouté. Merci!',
      place: 'Passer votre commande',
      shippingTo: 'Expédition à: ',
      editAddress: 'Éditer',
      error: "Euh! Une erreur s'est produite lors du traitement de votre carte.",
      info: 'Informations de paiement',
      creditDebit: 'Carte de crédit',
      onFile: 'Carte au dossier',
      useFile: 'Utiliser la carte dans le fichier',
      useDifferent: 'Utiliser une autre carte',
    },
  },
  basketPlusSavingsBanner: {
    headline: 'Réclamez les avantages Protection Plus de {petName}',
    body: 'Votre forfait comprend certains articles gratuitement. Les avantages du forfait et les promotions sont appliqués automatiquement au paiement.',
    shopNow: 'Magasinez maintenant!',
  },
  components: {
    discount: {
      notApplyTip:
        "Les codes promotionnels ne s'appliquent pas aux frais de licence pour animaux de compagnie, aux frais de retard, aux étiquettes de remplacement pour animaux de compagnie, aux articles groupés ou aux articles en vente spécifiques.",
      success: '',
      error: '',
      excludesSaleItems: 'Les codes promotionnels ne peuvent pas être utilisés sur les articles en solde.',
      automatedDiscountBlocksPromo: 'Une réduction d’adhésion est déjà appliquée à cette commande; les codes promotionnels ne peuvent donc pas être utilisés.',
    },
    petHeader: {
      for: 'Articles pour {0}',
    },
    product: {
      personalization: 'Personnalisation',
      free: 'GRATUIT',
      automatedDiscountLabel: {
        named: 'Remise {triggerName} appliquée',
        _default: 'Remise automatique appliquée',
      },
    },
    stripe: {
      AM: 'Amex',
      MC: 'Mastercard',
      VI: 'Visa',
      NN: 'Discover',
      XX: 'Card',
      profile: '{0} se terminant par {1} expirant le {2}/{3}',
    },
    totals: {
      subtotal: 'Sous-total',
      discount: 'Réduction',
      shipping: {
        regular: {
          text: 'Regular Mail Shipping',
        },
        priority: {
          upgradeText: 'Upgrade to Priority Shipping ${0}',
          downgradeText: 'Change to Regular Mail Shipping (Free)',
        },
      },
      free: 'FREE',
      tax: 'Tax ({0}) {1}%',
      fees: 'Frais',
      feesTip: "Ces frais couvrent les coûts liés au traitement de votre commande.",
      replacementTagFees: "Frais de traitement pour l'étiquette de remplacement",
      replacementTagFeesTip: "Des frais de traitement sont appliqués pour aider à couvrir les frais de carte de crédit pour le traitement de votre commande",
      donation: 'Don',
      total: 'Total',
    },
    removeBundleItemConfirmation: {
      title: 'Êtes-vous sûr de vouloir supprimer cet article de votre panier?',
      message: 'Cela supprimera tous les éléments associés {petName}.',
      messageNoPet: 'This will remove all of the items associated with the Pet ID Bundle.',
      confirmButtonText: "Oui, supprimez l'élément",
      cancelButtonText: 'Non, gardez cet article',
    },
    petFooter: {
      chooseTagForNextPet: 'Choisissez une médaille pour {petName}',
      addDesignerTag: 'Ajouter une étiquette design pour {petName}! | Ajouter une autre étiquette design pour {petName}!',
    },
  },
  membership: {
    switchError: "Nous n'avons pas pu modifier la fréquence de facturation. Veuillez réessayer.",
    switchToMonthly: 'Passer à la facturation mensuelle ({price})',
    switchToAnnual: 'Passer à la facturation annuelle et économiser {saving}',
    switchToAnnualNoSaving: 'Passer à la facturation annuelle ({price})',
    nowBilledMonthly: 'Facturation mensuelle, {price} par mois.',
    nowBilledAnnually: 'Facturation annuelle, {price} par an.',
    // Mirrored verbatim from translations/petowner/membership+intl-icu.fr_CA.xlf
    monthly_commitment_ack:
      "Je comprends qu'il s'agit d'un engagement de 1 an et j'accepte d'être facturé automatiquement chaque mois pendant 12 mois.",
    monthly_commitment_ack_error: "Veuillez cocher la case pour confirmer l'engagement de 1 an et les conditions de facturation.",
  },
  meta: {
    title: {
      Basket: 'Basket',
      Checkout: 'Checkout',
      Interrupt: 'Interrupt',
      Donation: 'Donation',
      Payment: 'Payment',
      Confirmation: 'Confirmation',
    },
  },
};
